import { breadcrumbSchema, clinicListSchema } from "../structured-data-core";
import { CLINICS } from "../clinics";

// A hub page lists the clinics and links to each clinic's own page. The
// clinic nodes live on those pages, not here.
export function getNationalStructuredData() {
  return [
    clinicListSchema("RESTORE Hair clinics", "/locations/restore-northeast/", CLINICS),
    breadcrumbSchema([
      { name: "Locations", path: "/locations/" },
      { name: "Nationwide", path: "/locations/restore-northeast/" },
    ]),
  ];
}
